import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const PrivacyIcon = createSvgIcon(
  <>
    <rect width="24" height="24" fill="var(--background-paper)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7V8.67363C14.0907 8.24169 13.0736 8 12 8C10.9264 8 9.90926 8.24169 9 8.67363V7ZM7 10.101V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10.101C18.2372 11.3636 19 13.0927 19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 13.0927 5.76281 11.3636 7 10.101ZM12 20C14.7614 20 17 17.7614 17 15C17 12.2386 14.7614 10 12 10C9.23858 10 7 12.2386 7 15C7 17.7614 9.23858 20 12 20ZM10 14C10 13.4477 10.4477 13 11 13H13C13.5523 13 14 13.4477 14 14C14 14.5523 13.5523 15 13 15V16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5V15C10.4477 15 10 14.5523 10 14Z"
      fill="currentColor"
    />
  </>,
  "PrivacyIcon"
);
